import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';

import { buildCard } from './buildCard';
import type { PetitionMarqueeCardData } from './types';

export type { PetitionMarqueeCardData } from './types';

type Result = ModelHookResult<
	{
		petitions: PetitionMarqueeCardData[];
	},
	{
		trackPetitionClick: (petitionId: string) => void;
	}
>;

export function usePetitionMarquee(): Result {
	const {
		data: { petitionMarqueeItems },
	} = useHomepagePageData();
	const { translatePlural } = useI18n();
	const track = useTracking();

	// memoized so useMarqueeRows only re-samples when the page data actually changes
	const petitions = useMemo(
		() => petitionMarqueeItems.flatMap((item, index) => buildCard(item, index, { translatePlural }) ?? []),
		[petitionMarqueeItems, translatePlural],
	);

	return {
		data: {
			petitions,
		},
		actions: {
			trackPetitionClick: (petitionId: string) => {
				void track('homepage_petition_marquee_click', { petition_id: petitionId });
			},
		},
	};
}
